import { RealEstateBenefit } from './real-estate-benefit.model';
import { RealEstateDeveloper } from './real-estate-developer.model';

export const realEstateProjectPhaseValues = [
  'delivery-soon',
  'immediate-delivery',
  'pre-sale',
] as const;
export type RealEstateProjectPhase = typeof realEstateProjectPhaseValues[number];
export const realEstateProjectPhaseLabels: Record<RealEstateProjectPhase, string> = {
  'delivery-soon': 'Próxima entrega',
  'immediate-delivery': 'Entrega inmediata',
  'pre-sale': 'Pre-venta',
};

export const realEstateProjectTypeValues = [
  'apartment',
  'house',
] as const;
export type RealEstateProjectType = typeof realEstateProjectTypeValues[number];
export const realEstateProjectTypeLabels: Record<RealEstateProjectType, string> = {
  'apartment': 'Departamento',
  'house': 'Casa',
};

export interface RealEstateProjectContact {
  email: string;
  lastName: string;
  name: string;
  phoneNumber: string;
}

export type RealEstateProjectTag = 'featured';

export const realEstateProjectAmenityValues = [
  'green-area',
  'grill',
  'gym',
  'laundry',
  'event-room',
  'pets',
  'pool',
  'playroom',
  'security',
  'sports-courts',
  'rooftop',
  'coworking',
] as const;
export type RealEstateProjectAmenity = typeof realEstateProjectAmenityValues[number];
export const realEstateProjectAmenityLabels: Record<RealEstateProjectAmenity, string> = {
  'coworking': 'Cowork',
  'event-room': 'Salón de eventos',
  'green-area': 'Áreas verdes',
  'grill': 'Asadores',
  'gym': 'Gimnasio',
  'laundry': 'Área de lavado',
  'pets': 'Mascotas',
  'playroom': 'Ludoteca',
  'pool': 'Alberca',
  'rooftop': 'Rooftop',
  'security': 'Seguridad 24/7',
  'sports-courts': 'Canchas deportivas',
};

export interface RealEstateProjectNearbyPlace {
  distance: number;
  label: string;
  travelTime: number;
}

export type RealEstateProjectNearbyGroupType =
  | 'metro-station'
  | 'bus-station'
  | 'school-university'
  | 'early-education'
  | 'park'
  | 'recreation-area'
  | 'shopping-service'
  | 'restaurant-cafe';

export const realEstateProjectNearbyGroupLabels: Record<RealEstateProjectNearbyGroupType, string> = {
  'bus-station': 'Paradas de autobús',
  'early-education': 'Educación inicial',
  'metro-station': 'Estaciones de metro',
  'park': 'Parques',
  'recreation-area': 'Espacios recreativos',
  'restaurant-cafe': 'Restaurantes y cafeterías',
  'school-university': 'Escuelas y universidades',
  'shopping-service': 'Compras y servicios',
};

export interface RealEstateProjectNearbyGroup {
  places: RealEstateProjectNearbyPlace[];
  type: RealEstateProjectNearbyGroupType;
}

export type RealEstateProjectNearbyCategoryType =
  | 'education'
  | 'green-space'
  | 'health'
  | 'leisure'
  | 'transportation'
  | 'shops';

export const realEstateProjectNearbyCategoryLabels: Record<RealEstateProjectNearbyCategoryType, string> = {
  'education': 'Educación',
  'green-space': 'Áreas verdes',
  'health': 'Salud',
  'leisure': 'Entretenimiento',
  'shops': 'Comercios',
  'transportation': 'Transporte',
};

export interface RealEstateProjectNearbyCategory {
  groups: RealEstateProjectNearbyGroup[];
  type: RealEstateProjectNearbyCategoryType;
}

export interface RealEstateProject {
  address: string | null;
  amenities: RealEstateProjectAmenity[];
  areaFrom: number;
  areaTo: number;
  bathroomsFrom: number;
  bathroomsTo: number;
  bedroomsFrom: number;
  bedroomsTo: number;
  contact: RealEstateProjectContact;
  createdAt: Date;
  description: string | null;
  endAt: Date;
  id: number;
  imageUrls: string[];
  latitude: number | null;
  longitude: number | null;
  municipality: string | null;
  name: string | null;
  phase: RealEstateProjectPhase;
  places: RealEstateProjectNearbyCategory[];
  postalCode: string | null;
  priceFrom: number;
  priceTo: number;
  province: string | null;
  publishedAt: Date | null;
  realEstateBenefitId: number | null;
  realEstateDeveloperId: number;
  referenceId: string;
  slug: string | null;
  startAt: Date;
  state: string | null;
  status: string;
  street: string | null;
  streetNumber: string | null;
  tags: RealEstateProjectTag[];
  totalUnits: number;
  type: RealEstateProjectType;
  updatedAt: Date;
}

export interface RealEstateProjectExpanded extends RealEstateProject {
  benefits: Pick<RealEstateBenefit, 'description' | 'id' | 'title'>[];
  developer: Pick<RealEstateDeveloper, 'id' | 'name' | 'logoUrl'>;
}
